import { render } from "./OrganizationModal.vue?vue&type=template&id=4ada67c3&scoped=true"
import script from "./OrganizationModal.vue?vue&type=script&lang=js"
export * from "./OrganizationModal.vue?vue&type=script&lang=js"

import "./OrganizationModal.vue?vue&type=style&index=0&id=4ada67c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ada67c3"]])

export default __exports__